export const getIdByParam = (param: string, route: string, separator = '/') => {
  const regexp = new RegExp(`/${param}${separator}*(.*?)(?=/|$)`, 'g')
  const regexResult = regexp.exec(route)
  return regexResult && regexResult[1]
}
